import React, { useEffect, useState } from "react";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

const STATS = [
  { key: "open",     label: "Open",     color: "#00ff90" },
  { key: "pending",  label: "Pending",  color: "#fbbf24" },
  { key: "resolved", label: "Resolved", color: "#60a5fa" },
  { key: "closed",   label: "Closed",   color: "rgba(255,255,255,0.3)" },
];

export default function TicketSummary({ refreshKey = 0 }) {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setLoading(false); return; }
    fetch(`${API_BASE}/api/tickets/summary`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(d => setSummary(d))
      .catch(() => setSummary({ open: 0, pending: 0, resolved: 0, closed: 0 }))
      .finally(() => setLoading(false));
  }, [refreshKey]);

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Ticket Summary</span>
      </div>
      <div className="p-4 grid grid-cols-4 gap-3">
        {STATS.map(({ key, label, color }) => (
          <div key={key} className="rounded-lg border border-white/5 bg-white/3 p-3 text-center">
            {loading ? (
              <div className="h-7 rounded bg-white/10 animate-pulse mb-1" />
            ) : (
              <p className="text-2xl font-bold" style={{ color }}>{summary?.[key] ?? 0}</p>
            )}
            <p className="text-xs text-white/30 mt-0.5">{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}